import * as React from "react";
import { connect } from "react-redux";
import { DottedLines } from "./DottedLines"
import { IConnectedModuleProps, IConnectedModuleState } from "src/interfaces";
import SingleCouncilService from "./SingleCouncil";
import { defaultYear } from 'src/constants/ApiSettings';
import SectionHeading from 'src/components/general/SectionHeading';
import { ICouncil } from "src/interfaces";
import axios from "axios";
import ServicePerson from "src/assets/service.png";
import { baseUrl } from "src/constants/ApiSettings";
import * as qs from "query-string-for-all";

interface IState extends IConnectedModuleState {
  scale: number;
  residents: null | number[];
}

class CouncilService extends React.PureComponent<
  IConnectedModuleProps,
  IState
> {

  constructor(props: IConnectedModuleProps) {
    super(props);

    const selectedYear = defaultYear;

    const scale = 1;

    this.state = { selectedYear, scale, residents: null };
  }

  public handleYearChange = (value: string) => {
    this.setState({ selectedYear: value });
    this.fetchScaleAndData(this.props.councils, value);
  };

  public componentDidMount() {
    this.fetchScaleAndData(this.props.councils, this.state.selectedYear);
  }

  public componentWillReceiveProps(newProps: IConnectedModuleProps) {
    if (newProps.defaultYear !== this.state.selectedYear) {
      if (newProps.defaultYear !== null) {
        this.fetchScaleAndData(newProps.councils, newProps.defaultYear);
      }
    }
  }

  public async fetchScaleAndData(_councils: ICouncil[], year:string){
    const data: number[] = [];
    let largestResidentCount = 0
    for await (const council of this.props.councils) {
      const item = await this.generateData(council, year) || 0
      const idx = data.push(item) -1
      const residents = data[idx]
      if (residents > largestResidentCount) {
        largestResidentCount = residents
      }
    };
    // Math for getting people going
    const maxPeople = 50; // They had 40 in the demo so 🤷
    const roof = largestResidentCount;
    const scale = roof > maxPeople ? maxPeople / roof : 1;
    this.setState({
      ...this.state,
      residents: data,
      scale
    })
  }

  public generateData = (council: ICouncil, year: string) => {
    return axios
      .get(
        `${baseUrl}/populationServicedPerEmployee?${qs.stringify({
          council: council.id,
          year
        })}`
      )
      .then(res => {
        const residentsRaw = res.data[0].value;

        const residents = Math.ceil(residentsRaw);

        return residents;
      })
      // tslint:disable-next-line:no-console
      .catch(err => console.error(err));
  };

  public render() {
    if (this.state.residents === null) {
      return null;
    }
    if (this.state.residents[0] === undefined) {
      return null;
    }
    const data = this.state.residents;
    return (
      <div className="container" id="service">
        <div className="row my-16 text-white">
          <div className="flex flex-wrap items-center justify-center content-center w-full">
            <SectionHeading
              heading="Population serviced per council employee"
              alignment="center"
              yearPicker={ this.handleYearChange }
              year={ this.state.selectedYear }
              learnMore={ "populationServicedPerEmployee" }
              councilSays={ "populationServicedPerEmployeeCouncilSays" }
              inverse={ true }
            />

            <p className="w-full py-4 lg:text-center">
              This is how many residents are within your council's geographical
              area for each council full-time equivalent (FTE) employee.
            </p>
            <div className="hidden lg:block">
              <div className="w-full justify-center flex">
                <div className="w-24">
                  <img
                    src={ServicePerson}
                    alt="Service Person graphic"
                  />
                </div>
              </div>
            </div>
            <div className="hidden lg:block"><DottedLines councils={this.props.councils} /></div>
            <div className="flex items-center justify-start w-full flex-wrap">
              {this.props.councils.map(
                (council, index) => (
                  <SingleCouncilService
                    key={index}
                    ordinal={index + 1}
                    council={council}
                    year={this.state.selectedYear}
                    meeples={data[index] * this.state.scale}
                    residents={data[index]}
                  />
                )
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  defaultYear:
    state.selectables.years.length > 0 ? state.selectables.years[0] : null,
  councils: state.selected.councils,
  
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CouncilService);



// WEBPACK FOOTER //
// ./src/components/report/councilExpenditure/CouncilService/index.tsx